// @ts-nocheck
import { PROFILE_ERROR, PROFILE_LOADING, PROFILE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_LOADING:
            return Object.assign({}, state, { loading: true })
        case PROFILE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case PROFILE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

